import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);

export const CompareProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("compare_items") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("compare_items", JSON.stringify(items));
  }, [items]);

  const toggle = useCallback((program) => {
    setItems((prev) => {
      if (prev.find((p) => p.slug === program.slug)) {
        return prev.filter((p) => p.slug !== program.slug);
      }
      if (prev.length >= 4) {
        toast.error("You can compare up to 4 programs");
        return prev;
      }
      toast.success(`${program.name} added to comparison`);
      return [...prev, { slug: program.slug, name: program.name }];
    });
  }, []);

  const remove = useCallback((slug) => setItems((prev) => prev.filter((p) => p.slug !== slug)), []);
  const setAll = useCallback((list) => setItems(list.slice(0, 4)), []);
  const clear = useCallback(() => setItems([]), []);
  const has = useCallback((slug) => items.some((p) => p.slug === slug), [items]);

  const value = useMemo(
    () => ({ items, toggle, remove, clear, has, setAll }),
    [items, toggle, remove, clear, has, setAll]
  );

  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
};

export const useCompare = () => useContext(CompareContext);
